"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: 40px;\n  height: 24px;\n  border-radius: 12px;\n  background: ", ";\n  cursor: pointer;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  &.on {\n    background: ", ";\n\n    &::before {\n      margin: 4px 4px 4px auto;\n    }\n\n    &.disabled {\n      background: ", "35;\n    }\n  }\n\n  &::before {\n    content: '';\n    width: 16px;\n    height: 16px;\n    background: ", ";\n    border-radius: 8px;\n    margin: 4px auto 4px 4px;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    &:not(.on) {\n      border: 1px solid ", ";\n      background: ", ";\n\n      &::before {\n        background: ", ";\n        margin: 3px auto 4px 4px;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: 40px;\n  height: 24px;\n  border-radius: 12px;\n  background: ", ";\n  cursor: pointer;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  &.on {\n    background: ", ";\n\n    &::before {\n      margin: 4px 4px 4px auto;\n    }\n\n    &.disabled {\n      background: ", "35;\n    }\n  }\n\n  &::before {\n    content: '';\n    width: 16px;\n    height: 16px;\n    background: ", ";\n    border-radius: 8px;\n    margin: 4px auto 4px 4px;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    &:not(.on) {\n      border: 1px solid ", ";\n      background: ", ";\n\n      &::before {\n        background: ", ";\n        margin: 3px auto 4px 4px;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.dark;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map